import { type GitpodAPI } from "@/api";
import { createContext } from "react";

// @ts-expect-error Can't initialize context with empty object
export const GitpodAPIContext = createContext<GitpodAPI>();
